import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from '@mui/material'
import { content } from './products.content'
import { Section } from '../../../../components'

export default function GuidelineModal({ isOpen, onClose, ...props }) {
  const modal = content.modalGuideline
  return (
    <Dialog fullWidth maxWidth={'sm'} open={isOpen} onClose={onClose} {...props}>
      <DialogTitle>{modal.headline}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {modal.items.map((item, index) => (
            <Section
              key={`${item.title}-${index}`}
              spacing={index > 0 && 'topMedium'}
              headline={item.title}
            >
              <Typography>{item.text}</Typography>
            </Section>
          ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{content.ui.close}</Button>
      </DialogActions>
    </Dialog>
  )
}
